import { render, staticRenderFns } from "./ReferralProgramUpdateForm.vue?vue&type=template&id=4aba52b4&"
import script from "./ReferralProgramUpdateForm.vue?vue&type=script&lang=js&"
export * from "./ReferralProgramUpdateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4aba52b4')) {
      api.createRecord('4aba52b4', component.options)
    } else {
      api.reload('4aba52b4', component.options)
    }
    module.hot.accept("./ReferralProgramUpdateForm.vue?vue&type=template&id=4aba52b4&", function () {
      api.rerender('4aba52b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ReferralProgramUpdateForm.vue"
export default component.exports